import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState } from "react";
import { fireDB } from "../../firebase/FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter a valid email!");
      return;
    }

    try {
      await addDoc(collection(fireDB, "subscribers"), { email });
      setMessage("Subscribed successfully! 🎉");
      setEmail("");
    } catch (error) {
      setMessage("Subscription failed. Try again!");
      console.error("Error:", error);
    }
  };

  return (
    <footer className="bg-[#b76d68] text-white py-14">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* About WeddingStay */}
          <div>
            <h3 className="text-xl font-serif mb-4">Wedding Stays</h3>
            <p className="text-sm leading-relaxed text-white/90">
              Discover luxury wedding stays and destination venues crafted for
              unforgettable celebrations. From royal palaces to beachfront
              resorts — we make your dream wedding come true.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-black">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/resorts" className="hover:text-black">
                  Our Resorts
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="hover:text-black">
                  Blogs
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-black">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-black">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/termsAndConditions" className="hover:text-black">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-black">
                  Privacy Policy
                </Link>
              </li>
              {/* <li>
                <Link to="/refund-policy" className="hover:text-black">
                  Cancellation Policy
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Stay Inspired</h3>
            <p className="text-sm mb-4 text-white/90">
              Subscribe to receive exclusive wedding venue offers and planning
              tips.
            </p>

            <form
              onSubmit={handleSubscribe}
              className="flex items-center overflow-hidden rounded-md bg-white"
            >
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="px-4 py-2 w-full text-gray-800 focus:outline-none"
                required
              />
              <button
                type="submit"
                className="bg-black text-white px-4 py-2 hover:bg-gray-800 transition"
              >
                Subscribe
              </button>
            </form>

            {message && <p className="text-xs mt-2 text-white">{message}</p>}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/30 my-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Copyright */}
          <p className="text-sm text-white/80 text-center">
            © {new Date().getFullYear()} Wedding Stays. All Rights Reserved.
          </p>

          {/* Social Icons */}
          <div className="flex space-x-6">
            <a href="#" className="hover:text-black transition">
              <FaInstagram size={20} />
            </a>
            <a href="#" className="hover:text-black transition">
              <FaFacebookF size={20} />
            </a>
            {/* <a href="#" className="hover:text-black transition">
              <FaYoutube size={20} />
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
